import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import styled from 'foundations-theming/utils';
import { trellisBreakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { CrossedOutPrice, PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { ANNUAL, MONTHLY } from 'self-service-api/constants/Terms';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ResponsivePrice = styled.span.withConfig({
  displayName: "SummaryColumnPriceDisplaySection__ResponsivePrice",
  componentId: "sc-71fy6c-0"
})(({
  theme
}) => {
  return Object.assign({}, theme.typography['heading-700'], {
    [trellisBreakpoint.tablet]: Object.assign({}, theme.typography['heading-800'])
  });
});
const MonthlyPrice = props => {
  return /*#__PURE__*/_jsx(ResponsivePrice, {
    children: /*#__PURE__*/_jsx(PriceDisplay, Object.assign({}, props))
  });
};
const PerMonthSubtext = styled.span.withConfig({
  displayName: "SummaryColumnPriceDisplaySection__PerMonthSubtext",
  componentId: "sc-71fy6c-1"
})(({
  theme
}) => Object.assign({}, theme.typography['heading-700'], {
  display: 'inline-flex'
}));
const StyledPricePerYearText = styled.span.withConfig({
  displayName: "SummaryColumnPriceDisplaySection__StyledPricePerYearText",
  componentId: "sc-71fy6c-2"
})(({
  theme
}) => ({
  color: theme.color['text-positive-default']
}));
const BillingTermText = styled.span.withConfig({
  displayName: "SummaryColumnPriceDisplaySection__BillingTermText",
  componentId: "sc-71fy6c-3"
})(({
  theme
}) => Object.assign({
  display: 'block',
  marginTop: theme.space[300],
  marginBottom: theme.space[100],
  color: theme.color['text-core-default']
}, theme.typography['heading-300']));
const BillingTermSubtext = styled.span.withConfig({
  displayName: "SummaryColumnPriceDisplaySection__BillingTermSubtext",
  componentId: "sc-71fy6c-4"
})(({
  theme
}) => Object.assign({
  display: 'block'
}, theme.typography['body-100'], {
  color: theme.color['text-core-default']
}));
const Bold = styled.span.withConfig({
  displayName: "SummaryColumnPriceDisplaySection__Bold",
  componentId: "sc-71fy6c-5"
})(({
  theme
}) => Object.assign({}, theme.typography['body-200'], {
  color: theme.color['text-core-default']
}));
const Wrapper = styled.div.withConfig({
  displayName: "SummaryColumnPriceDisplaySection__Wrapper",
  componentId: "sc-71fy6c-6"
})([""]);
const Block = styled.div.withConfig({
  displayName: "SummaryColumnPriceDisplaySection__Block",
  componentId: "sc-71fy6c-7"
})([""]);
export const SummaryColumnPriceDisplaySection = ({
  annualCostPrice,
  annualListPrice,
  monthlyCostPrice,
  activeCurrencyCode,
  term,
  costToGetStarted,
  showTotalPriceAsterisk = false
}) => {
  const hasGreaterStartingCost = costToGetStarted > 0 && costToGetStarted > (term === ANNUAL ? annualCostPrice : monthlyCostPrice);
  const hasHiddenCost = costToGetStarted > 0 && showTotalPriceAsterisk;
  const showCostToGetStarted = hasGreaterStartingCost || hasHiddenCost;
  const calculatedPriceDisplay = /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: term && monthlyCostPrice > 0 ? term === MONTHLY ? 'planBuilder.priceDisplay.pricingBilledMonthly_jsx' : 'planBuilder.priceDisplay.pricingBilledAnnually_jsx' : 'planBuilder.priceDisplay.pricingNoBillingTerm_jsx',
    elements: {
      MonthlyPrice,
      PerMonthSubtext,
      BillingTermText,
      BillingTermSubtext,
      AnnualPrice: PriceDisplay,
      StyledPricePerYearText,
      Bold,
      // Only show crossed-out original price if list price and cost price are different
      CrossedOutPrice: annualListPrice === annualCostPrice ? () => null : CrossedOutPrice,
      Wrapper,
      Block
    },
    options: {
      monthlyPriceProps: {
        price: monthlyCostPrice,
        currencyCode: activeCurrencyCode,
        dataSelenium: 'plan-builder-monthly-price',
        dataDiscounted: annualListPrice > annualCostPrice
      },
      annualPriceProps: {
        price: annualCostPrice,
        currencyCode: activeCurrencyCode,
        dataSelenium: !showCostToGetStarted && 'plan-builder-total-price'
      },
      crossedOutPriceProps: {
        price: annualListPrice,
        currencyCode: activeCurrencyCode
      },
      wrapperProps: {
        dataDiscounted: annualListPrice > annualCostPrice
      }
    }
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      children: calculatedPriceDisplay
    }), showCostToGetStarted && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "body-125",
        paddingInline: "500",
        marginBlockStart: "500",
        marginBlockEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "planBuilder.priceDisplay.estimatedCost"
        })
      }), /*#__PURE__*/_jsxs(Text, {
        typography: "body-300",
        children: [/*#__PURE__*/_jsx(PriceDisplay, {
          currencyCode: activeCurrencyCode,
          price: costToGetStarted,
          "data-selenium-id": "plan-builder-total-price"
        }), showTotalPriceAsterisk && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "planBuilder.requiredOnboardingSubtext.asterisk"
        })]
      })]
    })]
  });
};